<div aria-labelledby="Session time out pop up window">
    <f-modal role="dialog" size="large" variant="dialog" position="center" [visible]="defaultModalVisible" aria-modal="true">
        <div style= "margin-bottom: 12px">
            <H4>Session timeout warning</H4>
        </div>
        <div>
            <p style="font-size:15px;">Your session is about to end due to inactivity. Select the Extend button to continue browsing the site or Log Off button if finished.</p>
        </div>
        <div class="modal-footer">
            <f-button type="button" variant="action" text="Extend" (buttonClicked)="onModalExtentButtonClicked()"></f-button>
            <f-button type="button" variant="progressive" text="Log off" (buttonClicked)="onModalLogoffButtonClicked()"></f-button>
        </div>
    </f-modal>
</div>

    


